import ProductionSummaryType from "./actionTypes"



// function that called as action
const getList = data => ({
  type: ProductionSummaryType.GET_PRODUCTION_SUMMARY_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListSuccess = data => ({
  type: ProductionSummaryType.GET_PRODUCTION_SUMMARY_LIST_SUCCESS,
  payload: data,
})


const ProductionSummaryAction = {

  getList,
  getListSuccess,

}

export default ProductionSummaryAction





